export const CHKK_K8S_CONNECTOR_VERSION = 'v0.1.14'; // image tag of the k8s connector (can change or remain the same between multiple versions of the k8s connector)
export const CHKK_CLUSTER_AGENT_VERSION = 'v0.1.14';
export const CHKK_TERRAFORM_K8S_CONNECTOR_VERSION = 'v0.1.7'; // https://github.com/chkk-io/terraform-chkk-k8s-connector
export const CHKK_OPERATOR_VERSION = 'v0.0.15'; // https://github.com/chkk-io/chkk-operator
export const CHKK_CLI_VERSION_MAJORMINORPATCH = 'v0.0.1'; // https://github.com/chkk-io/chkkcli/releases
